import $ from 'jquery';

$(document).ready(function() {
    $('.js-longrid-video-slider').slick({
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 4,
        arrows: true,
        infinite: false,
        centerMode: true,
        variableWidth: true,
        draggable: false,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    dots: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    infinite: false,
                    centerMode: true,
                    variableWidth: false,
                    draggable: true,
               }
            },
            {
                breakpoint: 520,
                settings: {
                    dots: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    infinite: false,
                    centerMode: true,
                    variableWidth: false,
                    draggable: true,
               }
            }
        ]
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/longrid/longrid-video-slider.js